/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Layout from "../../../containers/Layouts/Layout";
import { Helmet } from "react-helmet-async";
import guidebookContentStyle from "../guidebookContentStyle";
import backgroundTeaser from "../../../assets/img/guidebook/Teaser_Bussgeldbescheid_700px.jpg";
import TeaserSlogan from "../../Teaser/TeaserSlogan";
import HighlightBox from "../../Box/HighlightBox/HighlightBox";
import DoubleButton from "../../Button/DoubleButton";
import QuestionsContactSection from "../QuestionsContactSection/QuestionsContactSection";
import TextContainer from "../../Container/TextContainer";
import { gaSet } from "../../../services/cookieService";
import Typography from "@mui/material/Typography";
import { Box, Paper } from "@mui/material";

const GuidebookTrafficDisputeAccusation = () => {
  const title = "Ratgeber - Vorwurf anfechten | Legalbird";
  gaSet({ title: title });

  return (
    <Layout backgroundType={"serviceworld"}>
      <Helmet>
        <title>{title}</title>
        <meta
          name="description"
          content="Ihnen droht eine Geldstrafe, Punkte oder sogar der Verlust Ihres Führerscheins und Sie wollen wissen, welche Möglichkeiten Sie jetzt
               haben? Wir erklären Ihnen kurz zusammengefasst, was Sie beachten müssen und wie Sie am besten gegen den Vorwurf vorgehen können."
        />
      </Helmet>

      <Paper sx={guidebookContentStyle.paper}>
        <TeaserSlogan slogan={"Professionell gegen Bußgeldbescheid vorgehen"} backgroundImagePath={backgroundTeaser} height={300} headingColor={"#333333"} />

        <TextContainer>
          <p>
            Ihnen droht eine Geldstrafe, Punkte oder sogar der Verlust Ihres Führerscheins und Sie wollen wissen, welche Möglichkeiten Sie jetzt haben? Wir
            erklären Ihnen kurz zusammengefasst, was Sie beachten müssen und wie Sie am besten gegen den Vorwurf vorgehen können.
          </p>
          <hr />
          <Typography variant={"h4"} sx={guidebookContentStyle.subheader}>
            Das Recht zu schweigen
          </Typography>
          <p>
            Wichtig ist, dass Sie allgemein immer das Recht haben, zu schweigen. Bevor Sie sich in falsche Aussagen oder in Widersprüche verstricken, sollten
            Sie ohne Rücksprache mit einem Anwalt nie eine Aussage zu dem Vorwurf machen. Auch wenn Sie die vorgeworfene Ordnungswidrigkeit begangen haben,
            sollten Sie sich dazu zunächst nicht äußern.
          </p>
          <Typography variant={"h4"} sx={guidebookContentStyle.subheader}>
            Anwalt beauftragen
          </Typography>
          <p>
            Unabhängig davon, ob Sie bisher nur einen Anhörungs-/Zeugenfragebogen oder bereits den Bußgeldbescheid erhalten haben: Sie haben jederzeit das Recht
            zu schweigen und einen Anwalt zu beauftragen. Wenn Sie professionell gegen den Vorwurf vorgehen und zum Beispiel Ihren Führerschein behalten
            möchten, sollten Sie unbedingt einen Anwalt mit Ihrem Fall beauftragen. Wir haben jahrelange Erfahrung im Verkehrsrecht und können daher das
            bestmöglichste Ergebnis für Sie erzielen.
          </p>
          <HighlightBox headline={"2-Wochen-Frist für Widerspruch"}>
            <Box sx={guidebookContentStyle.centered}>
              <p>
                Gegen den Bußgeldbescheid kann nur innerhalb von zwei Wochen nach Zustellung bei Ihnen Einspruch eingelegt werden. Wird der Einspruch nicht
                innerhalb der Frist eingelegt, ist er unwirksam und wird von der Behörde als unzulässig verworfen.
              </p>
            </Box>
          </HighlightBox>
          <Typography variant={"h4"} sx={guidebookContentStyle.subheader}>
            Zahlt meine RSV?
          </Typography>
          <p>
            Wenn Sie im Voraus eine Rechtsschutzversicherung für Verkehrsrecht abgeschlossen haben, übernimmt die Versicherung in der Regel immer die gesamten
            Kosten. Somit wäre für Sie alles kostenlos. Wenn Sie einen Selbstbehalt vereinbart haben, übernimmt Legalbird diesen für Sie.
          </p>
          <Typography variant={"h4"} sx={guidebookContentStyle.subheader}>
            Kann ich auch ohne Rechtsschutzversicherung gegen den Bescheid vorgehen?
          </Typography>
          <p>
            Auch ohne Rechtsschutzversicherung müssen Sie sich bei Legalbird keine Sorgen um die Kosten machen. Die Ersteinschätzung Ihres Falls ist für Sie
            kostenlos. Wenn wir der Meinung sind, dass gegen den Vorwurf vorgegangen werden kann, wird vorab mit Ihnen alles zu den Zahlmöglichkeiten und Kosten
            besprochen und Sie können sicher sein, dass die Kosten jederzeit so gering wie möglich gehalten werden. Es gilt also immer: keine Kosten ohne
            Absprache, keine bösen Überraschungen!
          </p>
          <Typography variant={"h4"} sx={guidebookContentStyle.subheader}>
            Wie geht es jetzt genau weiter?
          </Typography>
          <ol>
            <li>Sie vervollständigen alle Angaben zu Ihrem Fall und laden Ihren Bescheid hoch.</li>
            <li>Wir prüfen Ihren Fall kostenlos.</li>
            <li>
              Wenn die Prüfung ergibt, dass Ihr Bescheid ungültig ist, erteilen Sie Ihre Vollmacht und es wird Einspruch eingelegt, Akteneinsicht beantragt und
              eine Stellungnahme eingereicht.
            </li>
            <li>Die zuständige Behörde wird sich dann zu Ihrem Fall äußern und bestenfalls den Bußgeldbescheid zurücknehmen.</li>
            <li>
              Wir übernehmen jegliche Kommunikation mit Behörden und Gerichten. Sie können sich also zurücklehnen und werden immer auf dem Laufenden gehalten!
            </li>
          </ol>
          <Typography variant={"h4"} sx={guidebookContentStyle.subheader}>
            Ihre Vorteile
          </Typography>
          <p>
            Wir sind Profis im Bereich Verkehrsrecht und kennen daher die verschiedenen Messmethoden und zahlreichen Fälle ganz genau. Sie erhalten kostenlos
            eine professionelle Ersteinschätzung und haben dann Experten an Ihrer Seite, die sich für eine Verhinderung oder zumindest Reduzierung Ihres
            Bußgeldbescheides einsetzen.
          </p>
          <DoubleButton
            buttonText={"Kostenlose Ersteinschätzung"}
            buttonLink={"/servicewelt"}
            backText={"Zurück zum Ratgeber"}
            backLink={"/ratgeber/verkehrsrecht"}
          />
          <QuestionsContactSection />
        </TextContainer>
      </Paper>
    </Layout>
  );
};

export default GuidebookTrafficDisputeAccusation;
